import React from 'react'
import mount from '../lib/mount'
import App from '../components/App'
import HeartButton from '../components/HeartButton'

document.addEventListener('turbolinks:load', () => {
  const matches = document.querySelectorAll("[id^='react-heart-button-']")
  matches.forEach((match) => {
    const data = JSON.parse(match.getAttribute('data'))
    mount(
      match,
      <App>
        <HeartButton
          heartableId={data.heartableId}
          href={data.href}
          labels={data.labels}/>
      </App>,
    )
  });
})
